import axios from 'axios'
import store from '@/store'
import {MessageBox, Message} from 'element-ui'
import {getUrlToken} from '@/utils/auth'

const baseURL = process.env.VUE_APP_BASE_URL + '/api'

const $axios = axios.create({
    baseURL,
    headers: {'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*'},
    transformResponse: [(data) => {
        return {...JSON.parse(data)}
    }]
})

let loadingNum = 0 // loading加载次数

// 显示loading
export function showLoading() {
    if (loadingNum <= 0) {
        store.dispatch('setLoading', true)
        loadingNum = 0
    }
    loadingNum++
}

// 隐藏loading
export function hideLoading() {
    loadingNum--
    if (loadingNum <= 0) {
        store.dispatch('setLoading', false)
        loadingNum = 0
    }
}

// 添加请求拦截器
$axios.interceptors.request.use(
    config => {

        if (config.method === 'get') {
            config.data = {}
        }

        const token = getUrlToken() || store.state.token
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        // config.data['year'] = store.state.year

        // 查看发送请求的接口有没有设置isLoading
        if (config.headers.isLoading !== false) {
            // 显示loading
            showLoading()
        }

        return config
    }, function (error) {
        return Promise.reject(error)
    }
)
// 添加响应拦截器
$axios.interceptors.response.use(
    response => {
        if (response.config.headers.isLoading === false) {
            // 不执行任何操作
        } else {
            // 隐藏loading
            hideLoading()
        }

        const res = response.data
        // 请求成功
        if (res.code === 200) {
            return res
        }
        // 请求不成功
        if (res.code !== 200) {
            // 身份验证失败，需要重新登录
            if (res.code === 401 || res.code === 403) {
                // 重新登录
                MessageBox.alert(res.message, {
                    confirmButtonText: '重新登录',
                    type: 'warning'
                }).then(() => {
                    store.dispatch('loginOut').then(() => {
                        location.reload()
                    })
                })
                return Promise.reject(new Error(res.message || 'Error'))
            }
            Message({
                message: res.message || 'Error',
                type: 'error',
                duration: 5000
            })
            return Promise.reject(new Error(res.message || 'Error'))
        }
    },
    error => {
        if (error.config.headers.isLoading === false) {
            // 不执行任何操作
        } else {
            // 隐藏loading
            hideLoading()
        }
        console.log(error.response.data)
        if (error?.response?.data?.code === 403) {
            // 重新登录
            MessageBox.alert(error?.response?.data?.message || '登录已失效，请您重新登录', {
                confirmButtonText: '重新登录',
                type: 'warning'
            }).then(() => {
                store.dispatch('loginOut').then(() => {
                    location.reload()
                })
            })
            return Promise.reject(new Error(error?.response?.data?.message || 'Error'))
        }
        Message({
            message: error?.response?.data?.message || '请求失败，请重试～',
            type: 'error',
            duration: 5000
        })

        return Promise.reject(error)
    }
)
export default $axios
